/* eslint-disable react/prop-types */
import CardViewCorrelatedAnnouncementComponent from "./card-view-announcement";
import * as announcementHelper from "@/common/announcement-helper";
import * as helper from "@/common/helper";
import * as detailSlice from "@/common/components/announcement-detail/detail.slice";
import { useDispatch } from "react-redux";
function CardViewCorrelatedAnnouncement({ item, admin, offer }) {
  const dispatch = useDispatch();
  const status = announcementHelper.getStatus({ announcement: item });
  const date = helper.millisToDate({
    millis: item.correlationExpire,
  });

  const handleAnnouncementAdd = () => {
    if (!admin) {
      dispatch(
        detailSlice.updateOfferWithAnnouncement({
          annoucement: { ...item, status },
        })
      );
    }
  };

  const handleShowInfo = () => {
    dispatch(
      detailSlice.setModalAnnouncement({ annoucement: { ...item, status } })
    );
  };
  return (
    <CardViewCorrelatedAnnouncementComponent
      title={item.title}
      description={item.description}
      date={date}
      image={
        item.cardImageFileName
          ? `/images/announcement-images/${item.cardImageFileName}`
          : announcementHelper.PLACEHOLDER
      }
      status={status}
      isInOffer={item.isInOffer}
      admin={admin}
      onShowInfo={handleShowInfo}
      isSelectable={
        !admin
          ? announcementHelper.isAnnouncementSelectable(offer, item)
          : false
      }
      onAnnouncementAdd={handleAnnouncementAdd}
    />
  );
}

export default CardViewCorrelatedAnnouncement;
